// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__ZFA66","amount":"Amount_amount__hCxL_","tip":"Amount_tip__1Wfyh","tipHeader":"Amount_tipHeader__3PoCL","tipsWrap":"Amount_tipsWrap__1l88L"};